import { Component, Input, OnChanges } from "@angular/core";
import { UnitConversionService } from "@services/unitConversion.service";
import { TemperatureProbeCategory } from "@temperature/_enums/temperature/TemperatureProbeCategory.enum";
import { IZoneWithProbes } from "@temperature/_models/temperature/ITemperatureZone";
import { ZoneService } from "@temperature/_services/zone.service";

@Component({
    selector: 'zone-temperature',
    template: `<ng-container *ngIf="temperature || temperature == 0">{{temperature | unitConversion : true : "temperature"}}</ng-container>`
})
export class ZoneTemperatureComponent implements OnChanges {
    @Input() zones: IZoneWithProbes[];
    @Input() zonePosition: number;
    @Input() probeType: TemperatureProbeCategory;

    //--

    temperature: number;

    constructor(
        private readonly zoneService: ZoneService) { }

    ngOnChanges(): void {
        if (this.zones?.length) {

            this.getDisplayTemperature();
        }
    }

    //--

    private getDisplayTemperature() {
        const zone = this.zoneService.getZoneAtPosition(this.zones, this.zonePosition);
        const probe = zone?.probes?.find(probe => probe.Category === this.probeType);
        if (!probe) {
            return;
        }

        this.temperature = probe.latestRecord.Temperature;
    }
}
